import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
    FaTachometerAlt, FaUsers, FaUserShield, FaBriefcase, 
    FaWallet, FaSignOutAlt, FaShieldAlt, FaCogs, FaMoneyBillWave
} from 'react-icons/fa';

const AdminLayout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const navItems = [
        { path: '/admin', exact: true, icon: <FaTachometerAlt />, name: 'Overview' },
        { path: '/admin/users', icon: <FaUsers />, name: 'User Management' },
        { path: '/admin/categories', icon: <FaShieldAlt />, name: 'Categories' },
        { path: '/admin/forms', icon: <FaCogs />, name: 'Form Config' },
        { path: '/admin/verifications', icon: <FaUserShield />, name: 'Verifications' },
        { path: '/admin/withdrawals', icon: <FaMoneyBillWave />, name: 'Payouts' },
        { path: '/admin/jobs', icon: <FaBriefcase />, name: 'All Jobs' },
        { path: '/admin/wallet', icon: <FaWallet />, name: 'System Wallet' },
    ];

    const handleLogout = async () => {
        if (window.confirm("Logout from Admin Panel?")) {
            await logout(navigate);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex font-sans">
            {/* Sidebar (Hidden on Mobile) */}
            <aside className="hidden md:flex w-64 bg-slate-900 text-white flex-shrink-0 flex-col h-screen sticky top-0 overflow-y-auto">
                <div className="p-6 border-b border-slate-800 flex items-center gap-3">
                    <FaShieldAlt className="text-red-500 text-2xl" />
                    <h1 className="text-lg font-black tracking-wider uppercase">Admin Panel</h1>
                </div>

                <nav className="flex-grow p-4 space-y-2">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.name}
                            to={item.path}
                            end={item.exact}
                            className={({ isActive }) =>
                                `flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                                    isActive
                                        ? 'bg-red-600 text-white shadow-lg shadow-red-900/50'
                                        : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                                }`
                            }
                        >
                            {item.icon}
                            <span className="font-bold text-sm">{item.name}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="p-6 border-t border-slate-800">
                    <button 
                        onClick={handleLogout}
                        className="w-full flex items-center justify-center space-x-2 bg-slate-800 hover:bg-red-900/50 text-slate-300 hover:text-white py-3 rounded-xl transition-all"
                    >
                        <FaSignOutAlt />
                        <span className="font-bold text-sm">Logout</span>
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow p-8 bg-slate-100 h-screen overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
